<template>
  <v-main>
    <router-view />
  </v-main>
</template>
